import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import Grid from '@material-ui/core/Grid';
import { scrollBarStyle } from 'src/styles/CommonStyles.styled';

export const OrderDetailTabBody = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 82%;
    overflow-y: scroll;
    /* ${media.mobileDevice`
    padding-right: 3px;
    background: #ffffff;
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 6px;
    `} */
`;

export const MainDiv = styled.div`
    background: #ffffff;
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 6px;
    opacity: 1;
    margin: ${(props) => (props.margin ? props.margin : '10px 10px 10px 5px')};
    ${media.mobileDevice`
        margin: 10px 16px;
    `}
`;

export const Heading = styled.div`
    text-align: left;
    font-family: AvenirNextWorld Demi;
    color: #202124;
    font-size: 14px;
    opacity: 1;
    padding: 20px 0 0 20px;
`;

export const SubHeading = styled.div`
    text-align: left;
    font-family: AvenirNextWorld Demi;
    color: #202124;
    font-size: 13px;
    opacity: 1;
`;

export const Container2 = styled(Grid)`
    ${media.mobileDevice`
    background-color: white;
    `}
`;

export const Box = styled.div`
    padding: 20px 20px 0 22px;
`;

export const RoleBox = styled.div`
    padding: 20px;
`;
export const ButtonDiv = styled.div`
    justify-content: flex-end;
    display: flex;
    padding: 20px 11px 24px 0px;
`;

export const SalesMainDiv = styled.div`
    justify-content: space-between;
    display: flex;
    padding: 10px 0 5px 20px;
`;

export const SalesDiv = styled.div`
    font-size: 15px;
    display: block;
    font-family: AvenirNextWorld Regular;
    text-align: left;
    color: #000000;
    opacity: 0.6;
`;

export const ImgDiv = styled.div`
    padding: 0 16px 0 0;
`;

export const OrderSalesMobile = styled.div`
    display: none;
    ${media.mobileDevice`    
     display: contents;
    `}
`;

export const DesktopView = styled.div`
    display: contents;
    ${media.mobileDevice`    
     display: none;
    `}
`;

export const OrderDetailTabBodyContainer = styled.div`
    flex-grow: 1;
    overflow-y: scroll;
    height:  height: calc(100vh - 10rem - 60px);
    padding-bottom: 30px;
    box-sizing: border-box;
    ${scrollBarStyle}
    &::-webkit-scrollbar {
        display: contents;
        width: 5px;
    }

    &::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 10px;
        height: 12rem;
    }
    &::-webkit-scrollbar-thumb:hover {
        background: #555;
    }

    ${media.mobileDevice`
        &::-webkit-scrollbar {
            display: none;
        }
        padding-right: 0;
        padding-bottom: 80px;
        margin-top: 0px;
    `}
`;
